/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const UPDATEEVENT= createAsyncThunk(
  "updateEvent/updateEvent",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateEventSlice = createSlice({
  name: "updateEventSlice",
  initialState: {
    updateEvent: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateEvent: (state) => {
        state.updateEvent.loading = false
        state.updateEvent.error = false
        state.updateEvent.data = []
        state.updateEvent.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEEVENT.fulfilled, (state, action) => {
      state.updateEvent = {
        ...state.updateEvent,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEEVENT.pending, (state, action) => {
      state.updateEvent = {
        ...state.updateEvent,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEEVENT.rejected, (state, action) => {
      state.updateEvent = {
        ...state.updateEvent,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateEventAction = {
    UPDATEEVENT,
};

export { updateEventAction };
export default updateEventSlice.reducer;
export const {setInitialStateOfupdateEvent} = updateEventSlice.actions